module.exports = __webpack_public_path__ + "img/highest.71872570.svg";